const urlConfig = (url = null, action) => {
  switch (action.type) {
    case "GET_URL":
      return action.playload;
    default:
      return url;
  }
};
export default urlConfig;
